<rt-assistant-list-card [linkTarget]="linkTarget()" [label]="data().title" widgetType="task">
  <div class="rows">
    <div class="title-row">
      <rt-icon class="task-icon" name="checklist" colorToken="colorIconLowDefault" />
      <span class="title">{{ data().title }}</span>
    </div>
    <div class="bottom-row">
      @if (data().dueDate; as dueDate) {
        <span class="due">{{ dueDate | amDateFormat: 'D MMM YYYY, HH:mm' }}</span>
      }
      @if (avatarUsers().length > 0) {
        <rt-admins-avatars
          class="assignees"
          variant="ltr"
          avatarSize="small-x"
          [admins]="avatarUsers()"
          [stacked]="true"
          [limit]="3"
        />
      }
    </div>
  </div>
</rt-assistant-list-card>
